<div *ngIf="assessmentQuestions; else loading">
	<p class="obg-m-customer-assessments-title">{{ assessmentTitle }}</p>
	<div class="obg-m-customer-assessments-description" [innerHtml]="assessmentDescription"></div>
	<form
		class="obg-m-customer-assessments-form"
		[formGroup]="assessmentForm"
		(ngSubmit)="submit()"
		test-id="assessment-modal"
	>
		<div class="obg-m-customer-assessments-form-container">
			<ng-container *ngFor="let question of assessmentQuestions; trackBy: trackByQuestion">
				<div
					class="obg-m-customer-assessments-form-field"
					[ngSwitch]="getQuestionCategory(question.questionType)"
					[attr.test-id]="setTestId(question)"
				>
					<mat-form-field *ngSwitchCase="'auto'">
						<input
							name="'assessment-input-' + {{ question.questionId }}"
							[placeholder]="setPlaceholder(question)"
							type="text"
							matInput
							#autoCompleteInput
							[formControlName]="question.questionId"
							[matAutocomplete]="auto"
							(change)="updateValues(question, autoCompleteInput.value, getOtherId(question))"
							[id]="'assessment-input-' + question.questionId"
						/>
						<mat-autocomplete
							#auto="matAutocomplete"
							class="obg-m-customer-assessments-autocomplete"
							(optionSelected)="isOtherOptionSelected($event.option.id) && clearInput(question.questionId);
							updateValues(question, $event.option.value, $event.option.id)"
						>
							<mat-option
								*ngFor="let answer of question.availableAnswers; trackBy: trackByAnswer"
								[id]="'assessment-option-' + answer.answerId"
								[value]="answer.answerText"
							>
								{{ answer.answerText }}
							</mat-option>
						</mat-autocomplete>
					</mat-form-field>
					<mat-form-field *ngSwitchCase="'select'">
						<mat-select
							name="'assessment-input-' + {{ question.questionId }}"
							[placeholder]="question.questionText"
							#selectInput
							[multiple]="question.questionType === 'select-multiple'"
							[formControlName]="question.questionId"
							(selectionChange)="selectInput.multiple
								? updateMultiSelect(question, $event.source.selected)
								: updateValues(question, $event.value, $event.source.selected.id, false)"
							[aria-labelledby]="'assessment-label-' + question.questionId"
						>
							<mat-option
								*ngFor="let answer of question.availableAnswers; trackBy: trackByAnswer"
								[id]="'assessment-option-' + answer.answerId"
								[value]="answer.answerText"
							>
								{{ answer.answerText }}
							</mat-option>
						</mat-select>
					</mat-form-field>
					<ng-container *ngSwitchCase="'radio'">
						<label
							[id]="'assessment-label-' + question.questionId"
							[for]="'assessment-input-' + question.questionId"
							class="obg-m-customer-assessments-form-field-label"
							>{{ question.questionText }}</label
						>
						<mat-radio-group
							[formControlName]="question.questionId"
							(change)="updateValues(question, $event.value, $event.source.id)"
							[attr.aria-labelledby]="'assessment-label-' + question.questionId"
						>
							<mat-radio-button
								*ngFor="let answer of question.availableAnswers; trackBy: trackByAnswer"
								[id]="'assessment-input-' + answer.answerId"
								[value]="answer.answerText"
							>
								{{ answer.answerText }}
							</mat-radio-button>
						</mat-radio-group>
					</ng-container>
					<ng-container *ngSwitchCase="'checkbox'">
						<label
							[id]="'assessment-label-' + question.questionId"
							[for]="'assessment-input-' + question.questionId"
							class="obg-m-customer-assessments-form-field-label"
							>{{ question.questionText }}</label
						>
						<div
							class="checkbox-group"
							[attr.aria-labelledby]="'assessment-label-' + question.questionId"
							[formGroupName]="question.questionId"
							role="group"
						>
							<mat-checkbox
								*ngFor="let answer of question.availableAnswers; trackBy: trackByAnswer"
								[formControlName]="answer.answerId"
								[id]="'assessment-input-' + answer.answerId"
								[value]="answer.answerText"
								(change)="updateValues(question, $event.source.value, $event.source.id, true)"
							>
								{{ answer.answerText }}
							</mat-checkbox>
						</div>
					</ng-container>
					<mat-form-field *ngSwitchCase="'input'">
						<input
							name="'assessment-input-' + {{ question.questionId }}"
							[placeholder]="question.questionText"
							matInput
							[type]="getInputType(question.questionType)"
							[formControlName]="question.questionId"
							(change)="updateValues(question, $event.target.value, $event.target.id)"
							[id]="'assessment-input-' + question.questionId"
						/>
					</mat-form-field>

					<obg-common-validation-error
						*ngIf="isControlTouched(question.questionId) && questionError.get(question.questionId)"
						class="error-type"
						[ngClass]="getQuestionCategory(question.questionType)"
						[errorMessage]="questionError.get(question.questionId).errorMessage"
						[testId]="questionError.get(question.questionId).testId"
					>
					</obg-common-validation-error>
				</div>
			</ng-container>
		</div>
		<button
			mat-flat-button
			class="obg-m-customer-assessments-form-submit"
			color="accent"
			test-id="submit-button"
			type="submit"
			[disabled]="!assessmentForm?.valid"
		>
			{{ assessmentSubmitText }}
		</button>
	</form>
</div>

<ng-template #loading>
	<div class="spinner">
		<mat-spinner diameter="35"></mat-spinner>
	</div>
</ng-template>
